var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-2",attrs:{"min-width":"0","text":"","to":"/","exact":""}},[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("mdi-view-dashboard")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }